<template functional>
  <div
    :ref="data.ref"
    class="card-container"
    :class="[data.class, data.staticClass]"
    :style="{...data.style, ...data.staticStyle}"
    v-bind="data.attrs"
    v-on="listeners"
  >
    <v-card
      class="double-bottom"
      :style="{backgroundColor: props.bottomColor}"
    >
      <v-card-text>
        <slot
          name="bottom"
        />
      </v-card-text>
    </v-card>
    <v-card
      class="double-top"
      :style="{backgroundColor: props.topColor}"
    >
      <v-card-text
        class="double-top"
      >
        <slot />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    bottomColor: {
      type: String,
      default: 'rgba(255,255,255,0.85)'
    },
    topColor: {
      type: String,
      default: 'rgba(255,255,255,0.6)'
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  position: relative;
}
/deep/.double-top {
  height: 100%;
}
.double-bottom {
  position: absolute;
  top: 5px;
  right: 6px;
  width: 100%;
  height: 100%;
  text-align: right;
}
</style>
